module.exports = __webpack_public_path__ + "img/tryher-review-grid.ce723422.png";